module.exports = __webpack_public_path__ + "static/media/account.10756428.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/atoms/Icon/assets/account.svg
// module id = 588
// module chunks = 0